import { render, staticRenderFns } from "./ExportWitness.vue?vue&type=template&id=070eedab&"
import script from "./ExportWitness.vue?vue&type=script&lang=js&"
export * from "./ExportWitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports